var _defs, _polyline, _polyline2, _line, _line2, _line3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatformDevelopment03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#1292ee;stroke-miterlimit:10;}.cls-2{stroke-dasharray:2;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31.32 37.65 24.42 43.69 31.32 50.59"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "45.51 37.65 52.41 43.69 45.51 50.59"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.45,
    y1: 36.5,
    x2: 34.1,
    y2: 50.59
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.39,
    y1: 20.39,
    x2: 75.61,
    y2: 20.39
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.85,
    y1: 16.48,
    x2: 18.22,
    y2: 16.48
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.39,
    y: 12.58,
    width: 71.22,
    height: 54.83
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformDevelopment03);
export default __webpack_public_path__ + "static/media/Platform Development-03.8444101446064213f501278bf35f9941.svg";
export { ForwardRef as ReactComponent };